import React from 'react';
import { Link } from 'react-router-dom';
import { FaBuilding, FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import { useTenantInfo } from '../../hooks/useTenantInfo';
import './Footer.css';

const Footer = () => {
  const { displayName } = useTenantInfo();
  return (
    <footer className="website-footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-col">
            <div className="footer-brand">
              <div className="footer-logo">
                <FaBuilding />
                <span>RentTick</span>
              </div>
              <p>Comprehensive PG and Hostel management solution designed for {displayName}'s efficient operations and enhanced guest experiences.</p>
              <p className="copyright">By HeliaTick &copy; 2025</p>
            </div>
          </div>

          <div className="footer-col">
            <h4>Product</h4>
            <ul>
              <li><Link to="/services">Features</Link></li>
              <li><Link to="/pricing">Pricing</Link></li>
              <li><Link to="/clients">Clients</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Support</h4>
            <ul>
              <li><Link to="/contact">Contact Us</Link></li>
              <li><Link to="/terms">Terms</Link></li>
              <li><Link to="/privacy">Privacy</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Contact Info</h4>
            <div className="contact-info">
              <p><FaEnvelope /> heliatick.it@gmail.com</p>
              <p><FaPhone /> +91 9789340423</p>
              <p><FaMapMarkerAlt /> India</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
